<template>
    <div>
        <v-box-title v-model="date" title="客户统计" @change="change" />
        <el-row :gutter="30"> 
            <el-col v-for="item in list" :key="item.title" :md="12" :lg="6">
                <v-box-date-box :option="item" v-loading="loading" />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { apiGetCustomer } from '@/api/home'
export default {
    components: {
        VBoxTitle: () => import("@/views/wel2/components/v-box/Title"),
        VBoxDateBox: () => import("@/views/wel2/components/v-box/DateBox"),
    },
    data() {
        return {
            loading: false,
            date: moment(new Date()).format('YYYY-MM'),
            list: [
                {
                    title: "当前客户数量",
                    number: 0,
                    percentage: 0,
                    rows: [2400, 100, 2000, 1000, 1200, 1100, 1000, 1500, 3000, 2000, 2400, 1500, 2500, 1800, 1100],
                    colors: ["#58a3f7", "#FFF"],
                },
                {
                    title: "本月新增客户数",
                    number: 0,
                    percentage: 0,
                    rows: [0, 2, 4, 10, 0, 10, 20, 10, 15, 13, 11, 5, 8, 10, 5, 0],
                    colors: ["#8167f5", "#fff"],
                },
                {
                    title: "本月流失客户数",
                    number: 0,
                    percentage: 0,
                    rows: [80, 40, 20, 40, 30, 90, 85, 90, 100, 90, 95, 80, 70, 90, 70, 80, 40, 0],
                    colors: ["#fe9400", "#fff"],
                },
                {
                    title: "本月净增客户数",
                    number: 0,
                    percentage: 0,
                    rows: [50, 40, 30, 50, 20, 100, 80, 90, 70, 80, 90, 70, 90, 60],
                    colors: ["#4bced0", "#fff"],
                },
            ],
        };
    },
    created() {
        this.$emit('change', this.date)
    },
    mounted() {
        this.getList()
    },
    methods: {
        async getList() {
            // this.loading = true
            const { data } = await apiGetCustomer({
                month: moment(this.date).format('YYYY-MM')
            }).finally(() => { this.loading = false })
            this.list = [
                {
                    title: "当前客户数量",
                    number: this.getNumber(data.customerNum),
                    percentage: 0,
                    rows: [2400, 100, 2000, 1000, 1200, 1100, 1000, 1500, 3000, 2000, 2400, 1500, 2500, 2800, 3300],
                    colors: ["#58a3f7", "#FFF"],
                },
                {
                    title: "本月新增客户数",
                    number: this.getNumber(data.newCustomerNum),
                    percentage: this.getNumber(data.newCustomerPercentage),
                    rows: [0, 2, 4, 10, 0, 10, 20, 10, 15, 13, 11, 5, 8, 0, 5, 10],
                    colors: ["#8167f5", "#fff"],
                },
                {
                    title: "本月流失客户数",
                    number: this.getNumber(data.lossCustomerNum),
                    percentage: this.getNumber(data.lossCustomerPercentage),
                    rows: [80, 40, 20, 40, 30, 90, 85, 90, 100, 90, 95, 80, 70, 90, 70, 0, 40, 80],
                    colors: ["#fe9400", "#fff"],
                },
                {
                    title: "本月净增客户数",
                    number: this.getNumber(data.netCustomerNum),
                    percentage: this.getNumber(data.netCustomerPercentage),
                    rows: [50, 40, 30, 50, 20, 100, 80, 90, 70, 80, 90, 70, 60, 90],
                    colors: ["#4bced0", "#fff"],
                },
            ]
        },
        getNumber(value) {
            return isNaN(+value) ? 0 : +value
        },
        change() {
            this.getList()
            this.$emit('change', this.date)
        }
    }
};
</script>
